module.exports = __webpack_public_path__ + "img/h1.e20b56a7.png";